module.exports = __webpack_public_path__ + "img/activeIndex.ed0c906b.png";